import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import {useNavigate} from 'react-router-dom'
import api, {UpdateEdgeServer} from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useUpdateEdgeServer() {
  const {enqueueSnackbar} = useSnackbar()
  const client = useQueryClient()
  const navigate = useNavigate()
  const mutation = useMutation({
    mutationFn: async (server: UpdateEdgeServer) => {
      return await api.company.updateEdgeServer(server)
    },
    onSuccess: async () => {
      enqueueSnackbar('Servidor de borda configurado com sucesso', {variant: 'success'})
      await client.invalidateQueries({queryKey: [QueryKeyEnum.EDGE_SERVERS]})
      navigate('/registers/edge-servers')
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não foi possível salvar a configuração do servidor no momento')
    },
  })
  return mutation
}
